import React from "react";

const ElementCloneIndicator = ({ isClone }) => {
  if (!isClone) return null;

  return (
    <span
      className="elementCloneIndicator"
      title="This element shares model data with another element."
    >
      Clone
    </span>
  );
};

export default ElementCloneIndicator;
